import axios from "axios";
import { GetAxiosHeaders } from "../auth/GetAxiosHeaders";
import { CreateProfile } from "../lib/ShiOneClient";

const baseUrl = `${import.meta.env.API_ENDPOINT}/api/profile`;

export async function postRestMyUserProfile(profile: CreateProfile): Promise<void> {
  const axiosHeaders = await GetAxiosHeaders();

  await axios.post(baseUrl + "/updateprofile", profile, {
    headers: axiosHeaders,
  });
}